import React, { FC } from 'react';
import { Layout, Menu } from '@firesoon/antd';
import './index.less';
import { SiderP } from './interface';

const { Sider } = Layout;
const { SubMenu } = Menu;

const Index: FC<SiderP> = ({
  collapsed = false,
  selectedKeys = [],
  openKeys = [],
  menuTree = [],
  className = '',
  width = 160,
  collapsedWidth = 48,
  onCollapse,
  onSelect,
  handleClick,
  onSubMenu,
}) => {
  function formatTitle(item) {
    const { icon, icons } = item;

    if (icons?.length > 1) {
      const DefaultIcon = icons[0];
      const ActiveIcon = icons[1];

      return (
        <>
          <DefaultIcon className="anticon default" />
          <ActiveIcon className="anticon active" />
          <span title={item.title}>{item.title}</span>
        </>
      );
    }

    return (
      <>
        {icon ?? ''}
        <span title={item.title}>{item.title}</span>
      </>
    );
  }

  const loopMenu = (menu, onSubMenu: (e) => void) =>
    menu.map((v) => {
      if (v.isHide) {
        return null;
      }

      if (v.children?.length && !v.isHideChild) {
        return (
          <SubMenu
            onTitleClick={onSubMenu}
            key={v.id}
            disabled={v.disabled}
            title={formatTitle(v)}
            popupClassName="fs-subMenu"
          >
            {loopMenu(v.children, onSubMenu)}
          </SubMenu>
        );
      }

      return (
        <Menu.Item key={v.id} disabled={v.disabled}>
          {formatTitle(v)}
        </Menu.Item>
      );
    });

  const MenuItem = loopMenu(menuTree, onSubMenu);
  // fix: menu合上 设置openKeys导致hover时不显示menuItem，click才显示;且二级菜单会悬浮显示不消失
  const menuOpenKeyProp = !collapsed ? { openKeys } : {};

  return (
    <Sider
      collapsible
      className={`fs-sider ${className}`}
      collapsedWidth={collapsedWidth}
      width={width}
      collapsed={collapsed}
      onCollapse={onCollapse}
    >
      <Menu
        mode="inline"
        selectedKeys={selectedKeys}
        onSelect={onSelect}
        onClick={handleClick}
        inlineIndent={14}
        getPopupContainer={() => document.body}
        {...menuOpenKeyProp}
      >
        {MenuItem}
      </Menu>
    </Sider>
  );
};

export default Index;
